import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/CAP/CAPITAL_SPRING_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const CAP_SITE_INFORMATION = [
  '2000 Jetway Blvd',
  'Columbus, OH 43219',
  'Phone (614) 418 - 0250',
  'Fax (614) 418 - 0260',
  'FEIN: 38-2938499',
];

export function CAPQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} text="AS9100 Registered" />

        <SiteInformation name="Capital Springs" items={CAP_SITE_INFORMATION} />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} showCustomerPartId />

            {part.partSpecs && <PartSpecs specs={part.partSpecs} />}
            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>FOB:</Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>
            CERTIFICATION, FAIR & PPAP CHARGES (If required):
          </Text>
          <Text style={styles.textSmall}>
            Certificate of Conformance: $35.00/ purchase order line item
          </Text>
          <Text style={styles.textSmall}>
            Material Cert: $30.00/ purchase order line item
          </Text>
          <Text style={styles.textSmall}>
            Inspection Report: $75.00/ purchase order line item
          </Text>
          <Text style={styles.textSmall}>FAIR (AS9102): $500.00</Text>
          <Text style={styles.textSmall}>
            PPAP: $750.00 Other Certifications are quoted upon request.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.bold, styles.textSmall]}>
            Block Tolerances DO NOT APPLY to items on this quotation. Commercial
            tolerances per DIN 2089 will apply if not otherwise referenced on
            the drawing. We reserve the right to pass through increases in
            material, energy, freight and/or outside service cost in effect at
            the time of manufacture. Items ordered as part of a blanket or
            multiple release agreement must be taken with 12 months manufacture.
            Quoted delivery subject to material availability at time of order.
            DFAR items subject to material availability at time of order. To
            prevent any problems, parts not previously manufactured will have a
            quality assurance review prior to the start of production
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>
            <Text style={styles.bold}>Container Return Policy: </Text>
            All Buckhorn containers provided in the fulfillment of orders are
            the property of Capital Spring and must be returned. A fee of{' '}
            <Text style={styles.bold}>$300 per unreturned container </Text>
            will be invoiced to the customer for any containers not returned.
          </Text>
        </View>
      </View>
    </Page>
  );
}
